module.exports = "<app-loader></app-loader>\n<header>\n  <app-cabecalho></app-cabecalho>\n</header>\n<main>\n\t<div class=\"container\">\n\t\t<app-barra-progresso></app-barra-progresso>\n\t\t<div class=\"clear\"></div>\n\t\t<app-alerts></app-alerts>\n\t\t<router-outlet></router-outlet>\n\t</div>\n</main>\n<footer class=\"clear\">\n  <app-rodape></app-rodape>\n</footer>"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main